const HTTP_STATUS_CODE = {
  UNAUTHORIZED: 401
}

export const isUnauthorized = status => status === HTTP_STATUS_CODE.UNAUTHORIZED
export default { HTTP_STATUS_CODE, isUnauthorized }
